var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, IconButton, makeStyles } from '@material-ui/core';
import shadows from '@material-ui/core/styles/shadows';
import * as React from 'react';
import Icon from '@thingos/design-icons/web';
var useStyles = makeStyles(function () { return ({
    chip: {
        boxShadow: shadows[2],
        position: 'relative',
        display: 'inline-block',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 15,
        backgroundColor: '#FBFBFB',
        textTransform: 'none',
    },
    inner: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        textTransform: 'none',
        height: 30,
        borderRadius: 15,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 0,
        paddingBottom: 0,
        minWidth: 0,
    },
}); });
function withStoppedPropagation(callback) {
    if (callback == null) {
        return callback;
    }
    return function (event) {
        event.stopPropagation();
        callback(event);
    };
}
function isClickableTag(props) {
    return props.onClick != null;
}
export var Tag = function (_a) {
    var onDelete = _a.onDelete, DeleteButtonProps = _a.DeleteButtonProps, rest = __rest(_a, ["onDelete", "DeleteButtonProps"]);
    var styles = useStyles();
    var DeleteButton = function (_a) {
        var onDelete = _a.onDelete, rest = __rest(_a, ["onDelete"]);
        return (React.createElement(IconButton, __assign({ "aria-label": "Close", onClick: withStoppedPropagation(onDelete), style: { marginLeft: -8, marginRight: -8 } }, rest),
            React.createElement(Icon, { kind: "ui/delete", height: "18", width: "18" })));
    };
    var children = rest.children, restProps = __rest(rest, ["children"]);
    if (isClickableTag(restProps)) {
        var onClick = restProps.onClick, others = __rest(restProps, ["onClick"]);
        var clickableTagProps = __assign({ onClick: withStoppedPropagation(onClick) }, others);
        return (React.createElement("div", { className: styles.chip },
            React.createElement(Button, __assign({}, clickableTagProps, { className: styles.inner, fullWidth: true }),
                children,
                onDelete && React.createElement("div", { style: { width: 24 } })),
            onDelete && (React.createElement(DeleteButton, __assign({ onDelete: onDelete, style: { position: 'absolute', right: -6, top: -6 } }, DeleteButtonProps)))));
    }
    else {
        var nonClickableTagProps = restProps;
        return (React.createElement("div", __assign({ className: styles.chip }, nonClickableTagProps),
            React.createElement("div", { className: styles.inner },
                children,
                onDelete && React.createElement("div", { style: { width: 24 } })),
            onDelete && (React.createElement(DeleteButton, __assign({ onDelete: onDelete, style: { position: 'absolute', right: -6, top: -6 } }, DeleteButtonProps)))));
    }
};
